import React from 'react';

const ErrorIcon = (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.53125 8.125C0.125 7.4375 0.125 6.59375 0.53125 5.875L3.28125 1.125C3.6875 0.40625 4.4375 0 5.21875 0H10.75C11.5625 0 12.2812 0.40625 12.6875 1.125L15.4375 5.875C15.8438 6.59375 15.8438 7.4375 15.4375 8.125L12.6875 12.9062C12.2812 13.625 11.5625 14.0312 10.75 14.0312H5.21875C4.4375 14.0312 3.6875 13.625 3.28125 12.9062L0.53125 8.125ZM8 3C7.5625 3 7.25 3.34375 7.25 3.75V7.25C7.25 7.6875 7.5625 8 8 8C8.40625 8 8.75 7.6875 8.75 7.25V3.75C8.75 3.34375 8.40625 3 8 3ZM9 10C9 9.46875 8.53125 9 8 9C7.4375 9 7 9.46875 7 10C7 10.5625 7.4375 11 8 11C8.53125 11 9 10.5625 9 10Z"
      fill="#DC0A0A"
    />
  </svg>
);

export default ErrorIcon;
